import { TEMPLATE_DETAILS, TEMPLATE_DETAILS_SUCCESS, TEMPLATE_DETAILS_ERROR, TEMPLATE_DETAILS_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const TemplateDetails = (state = initialState, action) => {
  switch (action.type) {
    case TEMPLATE_DETAILS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case TEMPLATE_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case TEMPLATE_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case TEMPLATE_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default TemplateDetails;
